<template>
  <a-table v-bind="$attrs">
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.key === 'operate'">
        <a-button type="link" size="small" @click="editRecord(record)"
          >修改</a-button
        >
      </template>
      <template v-if="column.key === 'status'">
        <span>{{ text === 0 ? '启用' : '停用' }}</span>
      </template>
    </template>
  </a-table>
</template>
<script>
import { toRefs, inject } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
